import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

export interface DbBackupItem {
    name: string;
    fullPath: string;
    isFolder: boolean;
    sizeBytes?: number;
    lastModified?: string;
}

export interface DbBackupListResult {
    prefix: string;
    folders: DbBackupItem[];
    files: DbBackupItem[];
}

class DbBackupsService {
    async list(prefix?: string): Promise<DbBackupListResult> {
        const query = prefix ? `?prefix=${encodeURIComponent(prefix)}` : '';
        const url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/DbBackups/list${query}`;
        const response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error("Failed to list DB backups");
        }

        return response.json();
    }

    async getDownloadUrl(blobPath: string): Promise<string> {
        const url = `${process.env.REACT_APP_SELF_SERVICE_PEOPLEPLANNER_API_URL}/DbBackups/downloadurl?path=${encodeURIComponent(blobPath)}`;
        const response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error("Failed to get download URL");
        }

        return response.text();
    }
}

export default new DbBackupsService();
